import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'
import { MerchantData } from './insertMerchant'

const getMerchantRequestBody = (merchantData: any) => {
  return {
    csoName: merchantData['CSO Name'],
    csoMobile: {
      number: merchantData['CSO Mobile'],
      countryCode: '91',
    },
    jcName: merchantData['JC Name'],
    merchantId: merchantData.mid,
    jcMobile: {
      number: merchantData['JC No'],
      countryCode: '91',
    },
    terminalId: merchantData.terminalId,
  }
}

const insertCso = (merchantData: MerchantData, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.insertCso,
    body: getMerchantRequestBody(merchantData),
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.status === 'SUCCESS') {
      return data?.data?.status
    } else {
      throw data
    }
  })
}

export { insertCso }
